"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMultiplierBingo = exports.isScoreBingo = exports.isBingo = void 0;
const isObject_1 = require("./isObject");
const isBingo = (value) => {
    return (0, exports.isScoreBingo)(value) || (0, exports.isMultiplierBingo)(value);
};
exports.isBingo = isBingo;
const isScoreBingo = (value) => {
    return (0, isObject_1.isObject)(value) && 'score' in value && typeof value.score === 'number';
};
exports.isScoreBingo = isScoreBingo;
const isMultiplierBingo = (value) => {
    return (0, isObject_1.isObject)(value) && 'multiplier' in value && typeof value.multiplier === 'number';
};
exports.isMultiplierBingo = isMultiplierBingo;
